import { FolderDocument } from 'src/app/models/server/folder-document';

export class DialogSendEmailData {
    /**
     * Constructeur.
     * @param folderViewId : Id de la vue à laquelle appartient le dossier.
     * @param folderId : Id du dossier.
     * @param document : Instance du mail auquel on doit repondre (Renseigné en cas de réponse à un mail ou renvoi de mail, null autrement).
     * @param isResponse : Indique si le mail est une réponse à un mail existant (true si c'est une réponse, false si c'est renvoi de mail).
     */
    public constructor(
        public folderViewId: number,
        public folderId: string,
        public document: FolderDocument = null,
        public isResponse: boolean = false
    ) {}
}
